import { ReactNode } from 'react';

import { Button } from '@/design-system';

import { SendPageActions } from './send-page-layout';

export interface SendAction {
  label: string;
  icon?: ReactNode;
  disabled?: boolean;
  variant?: 'solid' | 'outline';
  onClick: () => void;
}

export interface SendActionsProps {
  primaryAction?: SendAction;
  secondaryAction?: SendAction;
}

export const SendActions = ({ primaryAction, secondaryAction }: SendActionsProps) => (
  <SendPageActions>
    {secondaryAction && (
      <Button
        fullWidth
        size="lg"
        variant={secondaryAction.variant ?? 'outline'}
        onClick={secondaryAction.onClick}
        disabled={secondaryAction.disabled}
      >
        {secondaryAction.icon}
        {secondaryAction.label}
      </Button>
    )}
    {primaryAction && (
      <Button
        fullWidth
        size="lg"
        variant={primaryAction.variant ?? 'solid'}
        onClick={primaryAction.onClick}
        disabled={primaryAction.disabled}
      >
        {primaryAction.icon}
        {primaryAction.label}
      </Button>
    )}
  </SendPageActions>
);
